import React from "react";

import { personalInformationPath } from "src/routes";
import { HeaderLinkProps } from "../constants";
import { RouterLink } from "src/_shared/ThemeTwo/Link/router-link.component";

export const PersonalInformation: React.FC<HeaderLinkProps> = ({ variant, linkLabel, onClickCallback }) => (
  <RouterLink.siteHeader
    variant={variant}
    to={personalInformationPath}
    onClick={onClickCallback}
  >
    {linkLabel}
  </RouterLink.siteHeader>
);
